export function createHeaderTableFixedRightClass (fixed, prefix = 'kye-table-v2-header') {
  return fixed === 'right' ? `${prefix}-fixed-right` : ''
}
export function createCssStyleUnit (value, defaultUnit = 'px') {
  const type = typeof value
  if (type === 'number') {
    return `${value}${defaultUnit}`
  } else if (type === 'string' && Number(value)) {
    return `${value}${defaultUnit}`
  } else {
    return value
  }
}
export function transformWHInStyle (obj = {}) {
  return Object.keys(obj).reduce((pre, k) => {
    pre[k] = createCssStyleUnit(obj[k])
    return pre
  }, {})
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/utils/style.js